module.exports = __webpack_public_path__ + "static/img/weather24.e8b681b4.png";